import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { ApplicationsPage } from '@/applications/pages/applications';

export const Route = createFileRoute('/applications/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: ApplicationsRoute,
  staticData: {
    headerSection: null
  }
});

function ApplicationsRoute() {
  return <ApplicationsPage/>;
}
